/**
 * Education Login Redirect Handler
 * Redirects customers with 'Education' tag to /pages/education after login
 */

(function() {
  'use strict';

  // Function to check if customer has Education tag
  function hasEducationTag() {
    // This will be populated by Liquid template
    return window.customerHasEducationTag === true;
  }

  // Function to handle education redirect
  function handleEducationRedirect() {
    // Check if this is a fresh login
    if (sessionStorage.getItem('checkEducationRedirect') === 'true') {
      // Clear the flag to prevent infinite redirects
      sessionStorage.removeItem('checkEducationRedirect');
      
      // Check if customer has Education tag
      if (hasEducationTag()) {
        // Redirect to education page
        window.location.href = '/pages/education';
      }
    }
  }

  // Function to set login flag
  function setLoginFlag() {
    const loginForm = document.querySelector('form[action*="/account/login"]');
    if (loginForm) {
      loginForm.addEventListener('submit', function() {
        sessionStorage.setItem('checkEducationRedirect', 'true');
      });
    }
  }

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    setLoginFlag();
    handleEducationRedirect();
  });

  // Also check on page load for immediate redirects
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleEducationRedirect);
  } else {
    handleEducationRedirect();
  }
})(); 